/**
 * User Interface
 *
 * Represents the complete user object returned from /v2/auth/login and /v2/users/me
 *
 * Permission data is available through nested objects:
 * - externalPermission: External user permissions (for roleID = 12)
 * - permissions: Internal user permissions
 */
export interface User {
	// Employee Core Fields
	employeeID: number;
	email: string;
	roleID: number;
	full_name: string;
	position: string;
	zoho_owner_id: string;
	employee_status: boolean;
	transunion_token_status: boolean | null;
	extension: string | null;
	company_id: number | null;
	company_name: string | null;
	agency_zoho_id: string | null;
	department_id: number | null;
	manager_dept_exception: boolean | null;
	collector_zoho_id: string | null;
	platform: string | null;
	last_logged_in: string | null;
	is_temp_password: boolean;
	password_expired: boolean;
	is_user_disabled: boolean;
	firebaseToken: string | null;
	ip_address: string | null;
	allowedNotification: boolean | null;
	externalPermission: ExternalPermission | null;
	permissions: Permissions | null;
	_canViewTimeline: boolean | null;
	_canEditSalesAgent: boolean | null;
	_canCancelLPP: boolean | null;
	_canCreateLoanAmendment: boolean | null;
	_staleDataNotification: StaleDataNotification;
	_coApplicantRemoveRestore?: CoApplicantRemoveRestore;
}

export interface ExternalPermission {
	row_id: number;
	employeeId: number;
	application_link: boolean;
}

export interface Permissions {
	cp_id: number;
	employeeID: number;
	collection_list: boolean;
	collection_manager_reports: boolean;
	ptp_finance: boolean;
	collection_dashboard_metrics: boolean;
	admin_dashboard: boolean;
	admin_report: boolean;
	insurance_cancellation: boolean;
	loan_servicing_reports: boolean;
	finance_nls_settings: boolean;
	external_collector_supervisor: boolean;
}

export const isExternalUser = (user: User): boolean => {
	return user?.roleID === 12;
};

export interface StaleDataNotification {
	showStaleOnSave: boolean;
	showStaleOnTabs: boolean;
}

/** Co-applicant actions in Details; each one is available unless its flag is false */
export interface CoApplicantRemoveRestore {
	showHistory: boolean;
	enableRemove: boolean;
	enableRestore: boolean;
}